"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickIdSync = exports.quickId = void 0;
const tslib_1 = require("tslib");
const async_1 = tslib_1.__importDefault(require("nanoid/async"));
const nanoid_1 = tslib_1.__importDefault(require("nanoid"));
const bitsPerChar = 6;
async function quickId(bits = 256) {
    return await (0, async_1.default)(Math.ceil(bits / bitsPerChar));
}
exports.quickId = quickId;
function quickIdSync(bits = 256) {
    return (0, nanoid_1.default)(Math.ceil(bits / bitsPerChar));
}
exports.quickIdSync = quickIdSync;
//# sourceMappingURL=quickId.js.map